export type Provider = "flywire" | "stripe" | "authnet";

interface UseProviderResult {
  getProvider: (region: string, sessionGateway?: Provider) => Provider;
}

export function useProvider(): UseProviderResult {
  const getProvider = (region: string, sessionGateway?: Provider): Provider => {
    if (
      sessionGateway === "authnet" ||
      sessionGateway === "stripe" ||
      sessionGateway === "flywire"
    ) {
      return sessionGateway;
    }

    const regionLower = region.toLowerCase();
    switch (regionLower) {
      case "br":
        return "stripe";
      default:
        return "flywire";
    }
  };

  return { getProvider };
}
